import React from 'react';
import { Grid } from '@material-ui/core';
import AzureAuthenticationButton from 'lib/azure/AzureAuthenticationButton';
import api from 'api';
import { useDispatch } from 'react-redux';
import { ToastsStore } from 'react-toasts';
import { completeAuthLogin } from 'redux/actions/authActions';

const azureClientId =
    process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;

const SingleSignInContainer = () => {
    const dispatch = useDispatch();
    const handleAzureAuthentication = ({ idToken }) => {
        api.auth.azure
            .login({ idToken })
            .then((result) => {
                const { success, token } = result;
                if (success) {
                    dispatch(completeAuthLogin(token));
                }
            })
            .catch((err) => {
                console.error(err);
                ToastsStore.error(
                    'Failed to login with azure account. Are you sure your coeus account has been set up or linked to your azure account?'
                );
            });
    };
    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item>
                <AzureAuthenticationButton
                    onAuthenticate={handleAzureAuthentication}
                    azureClientId={azureClientId}
                />
            </Grid>
        </Grid>
    );
};

export default SingleSignInContainer;
